/* v8: pawpouch-layout behaviours. Loads after theme.js (which keeps the cart drawer, menu, gallery thumbs, pack picker, sticky bar). */
(function () {
  // Countdown bar: evergreen (N minutes per visitor, restarts) or a fixed date (hides after it)
  document.querySelectorAll('[data-cdbar]').forEach(function (bar) {
    var mode = bar.getAttribute('data-mode'), key = 'll_cdbar_' + bar.getAttribute('data-minutes'), end;
    function fresh() { var v = Date.now() + (parseFloat(bar.getAttribute('data-minutes')) || 180) * 60000; try { localStorage.setItem(key, String(v)); } catch (e) {} return v; }
    if (mode === 'fixed') {
      end = new Date((bar.getAttribute('data-end') || '').trim().replace(' ', 'T')).getTime();
      if (isNaN(end)) { bar.hidden = true; return; }
    } else {
      var saved = NaN; try { saved = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      end = (saved && saved > Date.now()) ? saved : fresh();
    }
    var u = {}; ['days', 'hours', 'mins', 'secs'].forEach(function (k) { u[k] = bar.querySelector('[data-unit="' + k + '"]'); });
    function pad(n) { return ('0' + n).slice(-2); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { if (mode === 'evergreen') { end = fresh(); diff = end - Date.now(); } else { bar.hidden = true; return; } }
      var t = Math.floor(diff / 1000);
      u.days.textContent = pad(Math.floor(t / 86400)); u.hours.textContent = pad(Math.floor((t % 86400) / 3600));
      u.mins.textContent = pad(Math.floor((t % 3600) / 60)); u.secs.textContent = pad(t % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  // Delivery timeline: today plus the day offsets set in the editor
  document.querySelectorAll('[data-timeline]').forEach(function (tl) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function suffix(n) { if (n % 100 >= 11 && n % 100 <= 13) return 'th'; return ['th', 'st', 'nd', 'rd'][n % 10] || 'th'; }
    function fmt(d) { return months[d.getMonth()] + ' ' + d.getDate() + suffix(d.getDate()); }
    function plus(days) { var d = new Date(); d.setDate(d.getDate() + days); return d; }
    function range(attr) { var p = (tl.getAttribute(attr) || '1,2').split(','); return fmt(plus(+p[0])) + ' - ' + fmt(plus(+p[1])); }
    tl.querySelector('[data-tl-ordered]').textContent = fmt(new Date());
    tl.querySelector('[data-tl-ready]').textContent = range('data-ready');
    tl.querySelector('[data-tl-delivered]').textContent = range('data-delivered');
  });

  // People shopping now: a number between min and max that drifts by one every few seconds
  document.querySelectorAll('[data-visitors]').forEach(function (v) {
    var min = +v.getAttribute('data-min') || 3, max = +v.getAttribute('data-max') || 9, out = v.querySelector('[data-visitors-n]');
    var n = min + Math.floor(Math.random() * (max - min + 1));
    out.textContent = n;
    setInterval(function () { n = Math.min(max, Math.max(min, n + (Math.random() < 0.5 ? -1 : 1))); out.textContent = n; }, 9000 + Math.random() * 6000);
  });

  // Testimonial slider: auto-advances; the dots follow a finger swipe too
  document.querySelectorAll('[data-quotes]').forEach(function (q) {
    var track = q.querySelector('[data-quotes-track]'), slides = track.children, dots = q.querySelector('[data-quotes-dots]');
    if (slides.length < 2) { dots.remove(); return; }
    for (var i = 0; i < slides.length; i++) { var d = document.createElement('span'); if (!i) d.className = 'is-active'; dots.appendChild(d); }
    var idx = 0, pause = 0;
    function go(i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' }); }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      [].forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === i); });
      pause = Date.now() + 6000;
    }, { passive: true });
    setInterval(function () { if (Date.now() > pause) go(idx + 1); }, 4500);
  });

  // Popups (size guide)
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-modal-open]');
    if (open) { var m = document.querySelector('[data-modal="' + open.getAttribute('data-modal-open') + '"]'); if (m) m.hidden = false; return; }
    var modal = e.target.closest('[data-modal]');
    if (modal && (e.target === modal || e.target.closest('[data-modal-close]'))) modal.hidden = true;
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-modal]').forEach(function (m) { m.hidden = true; }); });

  // Video slider arrows: one clip per click
  document.querySelectorAll('[data-vslider]').forEach(function (s) {
    var track = s.querySelector('[data-vs-track]'); if (!track) return;
    var step = function () { var it = track.querySelector('.video-row__item'); return it ? it.getBoundingClientRect().width + 10 : track.clientWidth; };
    s.querySelector('[data-vs-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    s.querySelector('[data-vs-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // Numbered cards: on touch screens the card in the middle of the screen lights up (desktop uses hover)
  if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) { entries.forEach(function (en) { en.target.classList.toggle('is-active', en.isIntersecting); }); }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
    document.querySelectorAll('.cf-card').forEach(function (c) { cio.observe(c); });
  }

  // Product page extras: gallery arrows, add-ons inside the ladder box, "show from tier", price block
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var track = root.querySelector('[data-gallery-track]');
    var prev = root.querySelector('[data-gallery-prev]'), next = root.querySelector('[data-gallery-next]');
    if (prev && track) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next && track) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });

    // Move add-on rows and gift lines into the bundle ladder box, like pawpouch
    var extras = root.querySelector('[data-pack-extras]');
    if (extras) root.querySelectorAll('[data-addon], .gift-line, .gifts').forEach(function (el) { extras.appendChild(el); });

    var jsonEl = root.parentNode.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var money = function (cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
    };
    function syncFrom(index) {
      root.querySelectorAll('[data-addon]').forEach(function (a) {
        var from = +(a.getAttribute('data-show-from') || 0);
        var to = +(a.getAttribute('data-show-to') || 0);
        var show = (!from || index >= from) && (!to || index < to);
        a.hidden = !show;
        if (!show) { var c = a.querySelector('[data-addon-check]'); if (c) c.checked = false; a.classList.remove('is-checked'); }
      });
    }
    function syncPrice(v) {
      var pb = root.querySelector('[data-price-block]'); if (!pb || !v) return;
      pb.querySelector('[data-price-now]').textContent = money(v.price);
      var was = pb.querySelector('[data-price-was]'), save = pb.querySelector('[data-price-save]');
      var has = v.compare_at_price && v.compare_at_price > v.price;
      was.hidden = !has; save.hidden = !has;
      if (has) { was.textContent = money(v.compare_at_price); pb.querySelector('[data-price-pct]').textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price); }
    }
    syncFrom(+root.getAttribute('data-selected-index') || 1);
    root.querySelectorAll('[data-pack-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncFrom(+radio.closest('[data-pack]').getAttribute('data-pack-index'));
        if (product) syncPrice(product.variants.find(function (x) { return String(x.id) === radio.value; }));
      });
    });
  });
})();
